import React from 'react';

import DecommissioningReportContainer from '@totem/components/salesOrders/decommissioning/DecommissioningReportContainer';
import DecommissioningReportLayout, {
  DecommissioningReportExtra,
} from '@totem/components/salesOrders/decommissioning/DecommissioningReportLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const DecommissioningReportPage = () => (
  <ContentLayout>
    <DecommissioningReportContainer>
      <IBCard
        isCovered
        title="Services Not On Contract"
        extra={<DecommissioningReportExtra />}
      >
        <DecommissioningReportLayout />
      </IBCard>
    </DecommissioningReportContainer>
  </ContentLayout>
);

export default DecommissioningReportPage;
